/**
 * Деньги и проценты по языку витрины (#1335).
 *
 * Языки витрины → локаль для Intl. `lu` — не BCP 47 для люксембургского
 * (это код луба-катанга), поэтому явная карта, та же, что в `HeroSearch.jsx`.
 */
export const NUMBER_LOCALE = {
  en: 'en-GB',
  fr: 'fr-FR',
  de: 'de-DE',
  lu: 'de-LU',
  ru: 'ru-RU',
  el: 'el-GR',
};

export const numberLocale = (language) => NUMBER_LOCALE[language] || 'en-GB';

/** «€15,990» в en, «15 990 €» во fr/de — знак и разделители по локали. */
export const formatEuro = (value, language) =>
  new Intl.NumberFormat(numberLocale(language), {
    style: 'currency',
    currency: 'EUR',
    maximumFractionDigits: 0,
  }).format(value);

/** 0.0712 → «7.12%» в en, «7,12 %» во fr. */
export const formatPercent = (fraction, language) =>
  new Intl.NumberFormat(numberLocale(language), {
    style: 'percent',
    maximumFractionDigits: 2,
  }).format(fraction);
